module.exports = __webpack_public_path__ + "img/image-mt-2.155f385d.png";